import ftnUrl from '@/assets/coins/ftn.webp'
import usdcUrl from '@/assets/coins/usdc.webp'
import usdtUrl from '@/assets/coins/usdt.webp'
import btctUrl from '@/assets/coins/btc.webp'
import ethUrl from '@/assets/coins/eth.webp'
import amdtUrl from '@/assets/coins/amdt.webp'

export const coinList = {
  FTN: ftnUrl,
  USDT: usdtUrl,
  USDC: usdcUrl,
  BTC: btctUrl,
  ETH: ethUrl,
  AMDT: amdtUrl,
}
